import 'iframe-resizer/js/iframeResizer.contentWindow';
import React, { useEffect } from 'react';
import { createRoot } from 'react-dom/client';
import 'react-loading-skeleton/dist/skeleton.css';

import { App, loadContainers } from '@eika-infrastruktur/render';
import '@eika/base-style';
import '@eika/core-style';
import '@eika/layout-style';

import ComparisonTableApp from '../containers/comparison-table-app';
import { defaultConfig } from '../default-config';

import '../styles/main.scss';

const globalCssNamespace = 'forsikring-widgets';
const CONTEXT_PATH = 'forsikring-widget-web';
const comparisonTableNamespace = 'forsikring.widgets-comparison-table';

const renderApp = (
    MyApp: React.ComponentType<React.PropsWithChildren<unknown>>,
    namespace: string,
    appDefaultConfig: Record<string, unknown> = defaultConfig,
): void => {
    loadContainers(
        namespace,
        () => (
            <React.StrictMode>
                <div className={globalCssNamespace}>
                    <MyApp />
                </div>
            </React.StrictMode>
        ),
        appDefaultConfig,
    );
};

const ProductTableView = () => {
    useEffect(() => {
        renderApp(ComparisonTableApp, comparisonTableNamespace);
    }, []);
    const params = new URLSearchParams(window.location.search);
    const product = params.get('product');
    const appConfig = {
        data: {
            product: product?.toString().toLowerCase(),
            siteLang: 'nb',
        },
    };
    return (
        <div>
            <App namespace={comparisonTableNamespace} srcRoot={CONTEXT_PATH} config={appConfig} />
        </div>
    );
};

const container = document.getElementById('product-table-app');
const root = createRoot(container!);
root.render(
    <div className={globalCssNamespace}>
        <ProductTableView />
    </div>,
);
